// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sah-h","col":"styles_col__3FDxF"};